/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairSelfReacConfirmationRequest } from '../../models/finnair-self-reac-confirmation-request';
import { FinnairSelfReacConfirmationResponse } from '../../models/finnair-self-reac-confirmation-response';

export interface DisruptionConfirmAlternative$Params {
  orderId: string;
  locale?: string;
  hash?: string;
      body: FinnairSelfReacConfirmationRequest
}

export function disruptionConfirmAlternative(http: HttpClient, rootUrl: string, params: DisruptionConfirmAlternative$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairSelfReacConfirmationResponse>> {
  const rb = new DapiRequestBuilder(rootUrl, disruptionConfirmAlternative.PATH, 'post');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('locale', params.locale, {});
    rb.query('hash', params.hash, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairSelfReacConfirmationResponse>;
    }),
    catchErrorAsJson()
  );
}

disruptionConfirmAlternative.PATH = '/api/order/{orderId}/disruption-rebooking/confirm-alternative';
